import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import map from 'lodash/map'
import find from 'lodash/find'
import WorkspaceUserRow from './WorkspaceUserRow'
import classnames from 'classnames'

import {
  IWorkspaceUser,
} from '@SiteModules/WorkspaceUser/types'

import {
  deleteWorkspaceUser,
} from '@SiteModules/WorkspaceUser/actions'

import {
  getAccountUsers,
} from '@SiteModules/AccountUser/selectors'

import './WorkspaceUsersTable.scss'

interface WorkspaceUsersTableProps {
  readonly workspaceUsers: IWorkspaceUser[]
  readonly fullWorkspaceView: boolean
}

const WorkspaceUsersTable: React.FC<WorkspaceUsersTableProps> = props => {
  const dispatch = useDispatch()
  const { workspaceUsers, fullWorkspaceView } = props

  const accountUsers = useSelector(getAccountUsers)

  const renderTableHeader = () => {
    return (
      <tr>
        <th className="WorkspaceUsersTable__workspace-user">
          Members
        </th>
        <th className="WorkspaceUsersTable__access">
          Access
        </th>
      </tr>
    )
  }

  const workspaceUserRows = map(workspaceUsers, (workspaceUser, index) => {
    const handleDeleteWorkspaceUser = () => {
      dispatch(deleteWorkspaceUser({ workspaceUserId: workspaceUser.id }))
    }

    const accountUserInRow = find(accountUsers, accountUser => accountUser.id === workspaceUser.attributes.accountUserId)

    return (
      <WorkspaceUserRow
        key={index + 1}
        index={index + 1}
        userId={accountUserInRow ? accountUserInRow.attributes.userId : -1}
        name={accountUserInRow ? accountUserInRow.attributes.name : ''}
        email={accountUserInRow ? accountUserInRow.attributes.email : ''}
        accessType={workspaceUser.attributes.accessType}
        deleteWorkspaceUser={handleDeleteWorkspaceUser}
      />
    )
  })

  return (
    <div
      className={classnames(
        'WorkspaceUsersTable',
        { 'WorkspaceUsersTable__full': fullWorkspaceView}
      )}
    >
      <table>
        <thead>
          {renderTableHeader()}
        </thead>
        <tbody
          className={classnames(
            'WorkspaceUsersTable__body',
            { 'WorkspaceUsersTable__body-full': fullWorkspaceView }
          )}
        >
          {workspaceUserRows}
        </tbody>
      </table>
    </div>
  )
}

export default WorkspaceUsersTable
